import { Route, Routes } from 'react-router-dom';
import './projects.css';
import Navbar from '../navbar/navbar';
import Card from './card';
import PostMe from './images/postme.jpg';
import Buaran from './images/buaran.jpg';
import Privatengl from './images/privatengl.jpg';
import Lovecounter from './images/lovecounter.jpg';
import Sentiong from './images/sentiong.jpg';
import flowernamegenerator from './images/flower name gen.png';
import { useEffect, useState } from 'react';
import { getPageload, getPageVisit } from '../pagevisit/pagevisit';
function Projects() {
    const [projectState, setProjectState] =  useState(false);
    const [pageLoadState, setPageLoadState] = useState(false);

    console.log(getPageVisit());
    
    const interval = setInterval(() => {
        setPageLoadState(getPageload());
        
        
    }, 50);
    
    const times = (time) =>{
        if (getPageVisit() < 2){
            console.log('a');
            
            return 4500;
        }
        else{
            console.log('b');
            
            return 2500;
        }
    };


    
    useEffect(()=>{
        setTimeout(()=>{
            setProjectState(true);
        }, times())
    },[]);
    return (
        <>
            <Navbar page="projects" linkstate={3500}/>
        {projectState && (

            <div className={`projects${pageLoadState ? ' unload' : ''}`}>
            <div className="title">
                <h1 style={{position:"relative", bottom:"60px"}}>
                    My 
                    <span style={{color:"cyan", fontFamily:"monospace",position:'relative', right:'20px', fontStyle:'italic'}}> /Projects/</span>
                    {/* GbE incl? */}
                </h1>
            </div>
                <div className="projects">
                    <div className="cardContainer">
                        <Card name="PostMe" file={PostMe} time="01/01/2023" visitLink="https://postmeapp.netlify.app">
                        </Card>
                        <Card name="Kos Buaran website" file={Buaran} time="12/03/2023" visitLink="https://kosmurahbuaranraya.netlify.app">
                        </Card>
                        <Card name="My Private NGL" file={Privatengl} time="09/06/2023" visitLink="https://stephen-private-ngl.netlify.app">
                        </Card>
                        <Card name="Love Counter" file={Lovecounter} time="23/11/2022" visitLink="https://your-love-counter.netlify.app/">
                        </Card>
                        <Card name="Kos Sentiong Website" file={Sentiong} time="13/02/2023" visitLink="https://kosmurahsentiong.netlify.app">
                        </Card>
                        <Card name="Flower Name Generator" file={flowernamegenerator} time="13/02/2023" visitLink="https://flowernamegen.stepwebdev.me">
                        </Card>
                    </div>
                </div>
        </div>
        )}    
        </>
    );
}
export default Projects;